import {
  ObjectCondition,
  ObjectTrigger,
  SceneBlindState,
} from '@/../client-generator/generated-clients/plants';
import EnumToRadioButton from '@/views/components/EnumToRadioButton/EnumToRadioButton.vue';
import { Options } from 'vue-class-component';
import SceneTriggerAndConditionGeneral from '../SceneTriggerAndConditionGeneral';

@Options({
  name: 'TriggerAndConditionBlind',
  components: {
    EnumToRadioButton,
  },
})
export default class TriggerAndConditionBlind extends SceneTriggerAndConditionGeneral {
  SceneBlindState = SceneBlindState;
  declare triggerOrActionToAdd: ObjectTrigger | ObjectCondition;

  get isConfirmEnabled() {
    return this.triggerOrActionToAdd.blindState != SceneBlindState.None;
  }
}
